<template>
  <div class="bg-card d-flex justify-content-between rejected-interns">
    <strong>{{ $t('pages.offer-intern.rejected-interns.title') }}</strong>
    <div>{{ rejectedInternsCount }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rejectedInternsCount: 0
    }
  },
  mounted() {
    this.getRejectedCandidates();
  },
  methods: {
    getRejectedCandidates() {
      this.axios.get('offerApply/rejected-interns/' + this.$route.query.offer)
        .then( response => {
          this.rejectedInternsCount = response.data.length;
        })
        .catch();
    }
  }
}
</script>
